import POPUP_TPL from '../../../../resources/handlebars/rebrand2020/components/generic-modal.hbs';

export class GenericModal {
    constructor({title, subtitle, message, confirmLabel, cancelLabel, footnote, illustration}) {
        this.id = `confirmPopup_${new Date().getTime()}`;

        const modalMarkup = POPUP_TPL({
            confirmLabel,
            cancelLabel,
            id: this.id,
            confirmTitle: title,
            subtitle,
            confirmMessage: message,
            illustration,
            footnote,
        });

        $('body').append(modalMarkup);
        this.popup = $(`#${this.id}`);
    }

    /**
     *
     * @param callback (optional) function to be called before closing the modal on confirmation
     */
    show(callback) {
        this.popup.modal('show');
        this.popup.find('[data-confirm]').click((e) => {
            e.preventDefault();
            if (callback) {
                $(this).addClass('loading');
                Promise.resolve()
                    .then(callback)
                    .then(() => this.popup.modal('hide'))
                    .finally(() => $(this).removeClass('loading'));
            } else {
                this.popup.modal('hide');
            }
        });
    }
}
